import getRootState from './rootStateSelector';

export const getAuthState = (state) => getRootState(state).get('auth');

export const getIsCheckingAuth = (state) =>
  getAuthState(state).isAuthenticated === null;

export const getIsAuthLoading = (state) => getAuthState(state).isLoading;

export const getIsLoggedIn = (state) => getAuthState(state).isAuthenticated;

export const getIsNotLoggedIn = (state) => !getIsLoggedIn(state);
